module.exports = __webpack_public_path__ + "static/media/galerija_2023 (1).9be4f925.png";